module.exports = __webpack_public_path__ + "assets_1777427128813/img/logo.ab3d6f94.png";